<template lang="html">
    <section class="error-500">
        <h1 class="display-1 mb-0 text-center">500</h1>
    </section>
</template>
<script lang="js">
export default {
    name: 'error-500',
};
</script>



// WEBPACK FOOTER //
// src/views/sample-pages/error-500.vue